import { Marker, GoogleMap, LoadScript } from '@react-google-maps/api';
import { useKeysStore } from '../../../../../../core/store/useKeysStore';

function CustomMap(props) {
    const { keys } = useKeysStore();

    const containerStyle = {
        width: '100%',
        height: '100%'
    };

    const handleMarkerDragEnd = (event) => {
        const { latLng } = event;
        const lat = latLng.lat();
        const lng = latLng.lng();

        props.setMarkerPosition({ lat, lng });
    };

    return (
        <LoadScript googleMapsApiKey={keys?.gmaps_key}>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={props.markerPosition}
                zoom={17}
            >
                <Marker
                    position={props.markerPosition}
                    draggable={props.draggable ? true : false}
                    onDragEnd={handleMarkerDragEnd}
                />
            </GoogleMap>
        </LoadScript>
    );
}

export default CustomMap;
